export default __webpack_public_path__ + "static/awarepath_small-image_4-7ffcedc96672e0c890678794ac1933ad.png";